import React from "react";
import CookieBanner from "./CookieBanner";
import "./PopupContainer.scss";

const PopupContainer = () => {
  // const [showCookieBanner, setShowCookieBanner] = useState(false);
  // const [showFormPopup, setShowFormPopup] = useState(false);

  /*const checkVisibility = () => {
    const cookiePreferences = localStorage.getItem("cookiePreferences");
    setShowCookieBanner(!cookiePreferences);

    const formPopupSeen = localStorage.getItem("formPopupSeen");
    setShowFormPopup(!formPopupSeen);
  };*/

  /*useEffect(() => {
    checkVisibility();

    const handleStorageChange = () => {
      checkVisibility();
    };
    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(checkVisibility, 100);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);*/

  /*const getContainerClass = () => {
    if (showCookieBanner && showFormPopup) {
      return "popup-container both-visible";
    } else if (showCookieBanner && !showFormPopup) {
      return "popup-container cookie-only";
    } else if (!showCookieBanner && showFormPopup) {
      return "popup-container form-only";
    } else {
      return "popup-container none-visible";
    }
  };*/

  return (
    <div className={"popup-container cookie-only"}>
      {/*<div className={getContainerClass()}>*/}
      <CookieBanner />
      {/*<FormPopup />*/}
    </div>
  );
};

export default PopupContainer;
